import axios from "axios";
import { API_URL } from "../constants.js";

export const submitLabResult = async (sampleId) => {
  const response = await axios.post(API_URL + "docus/submit-lab-results", {
    sample_id: sampleId,
  });
  return response.data;
};

export const generateReport = async (sampleId) => {
  const response = await axios.post(API_URL + "docus/generate-report", {
    sample_id: sampleId,
  });
  return response.data;
};
